import React from 'react';

const checklistItems = [
    ['Modular Kitchen', 'Wardrobe Design', 'TV Unit', 'Study Room'],
    ['False Ceiling', 'Wall Paneling', 'Pooja Unit', 'Foyer Design'],
    ['Bathroom Design', 'Kids Bedroom', 'Electrical & Plumbing', 'Wall Painting'],
];

export default function BottomSections() {
    return (
        <>
            {/* Promo Banner */}
            <section className="relative overflow-hidden bg-gradient-to-r from-[#333333] via-[#444444] to-[#333333] py-16 px-4">
                {/* Glow effect */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-32 bg-[#2E63E8] rounded-full opacity-20 blur-3xl" />
                <div className="relative max-w-4xl mx-auto text-center">
                    <p className="text-gray-300 text-sm font-semibold uppercase tracking-widest mb-4">Special Offer</p>
                    <h2 className="text-3xl md:text-5xl font-bold text-white mb-2 leading-tight">
                        Just Visit{' '}
                        <span className="text-[#2E63E8] text-4xl md:text-6xl drop-shadow-lg">Bliv</span>
                        {' '}– We Will Beat That Price
                    </h2>
                    <p className="text-gray-300 text-base mt-4 mb-8">
                        Find a better quote anywhere? Bring it to us — we'll match and beat it, guaranteed.
                    </p>
                    <a
                        href="/contact"
                        className="inline-block border-2 border-[#2E63E8] text-[#2E63E8] hover:bg-[#2E63E8] hover:text-black font-bold px-10 py-4 rounded-xl transition-all duration-300 hover:shadow-[0_0_30px_rgba(245,197,24,0.4)] text-base"
                    >
                        Request a Quote
                    </a>
                </div>
            </section>

            {/* What Are You Looking For */}
            <section className="section-pad bg-[#f0f4fe]" id="looking-for">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">What are you looking For?</h2>
                        <div className="w-20 h-1 bg-[#2E63E8] mx-auto rounded-full"></div>
                        <p className="text-gray-600 mt-4 max-w-xl mx-auto">
                            From a single room makeover to complete home renovation — we cover it all with end-to-end solutions.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3 max-w-4xl mx-auto">
                        {checklistItems.map((col, colIdx) => (
                            <div key={colIdx} className="space-y-3">
                                {col.map((item, itemIdx) => (
                                    <div
                                        key={itemIdx}
                                        className="flex items-center gap-3 bg-white rounded-xl px-5 py-3.5 shadow-sm hover:shadow-md hover:border-[#2E63E8] border border-transparent transition-all duration-200 cursor-pointer group"
                                    >
                                        <span className="w-6 h-6 bg-[#2E63E8] rounded-full flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                                            <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                            </svg>
                                        </span>
                                        <span className="text-gray-800 font-medium text-sm">{item}</span>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>

                    <div className="text-center mt-10">
                        <a href="/contact" className="btn-yellow inline-block px-10 py-4 text-sm">
                            Start Your Project Today
                        </a>
                    </div>
                </div>
            </section>
        </>
    );
}
